import { BigNumber } from 'ethers';
import { useEffect, useState, useCallback } from 'react';

import { useTectonicSdk } from '@providers/TectonicSdkProvider';
import useWallets from '@hooks/useWallets';

const useXTonicBalance = () => {
  const [xTonicBalance, setXTonicBalance] = useState<BigNumber>(
    BigNumber.from(0)
  );

  const sdk = useTectonicSdk();
  const xTonicAddress = sdk?.Staking.getXTonic().address;

  const { currentAccount } = useWallets();

  const getXTonicBalance = useCallback(
    async (account: Null<string>) => {
      if (account) {
        const balance = await sdk.ERC20.balanceOf(xTonicAddress, account);
        return balance;
      }

      return BigNumber.from(0);
    },
    [sdk, xTonicAddress]
  );

  useEffect(() => {
    const balance = getXTonicBalance(currentAccount);

    balance.then((xTonicBal) => {
      setXTonicBalance(xTonicBal);
    });
  }, [currentAccount, getXTonicBalance]);

  return xTonicBalance;
};

export default useXTonicBalance;
